/**
 * Les routes poussées du lot Accueil : celles qu'il fait passer sur le design system.
 *
 * Aucune pontée à ce jour : le lot câble l'onglet (`Home/StudentHomeScreen.tsx`). La table existe
 * pour qu'une route ajoutée plus tard ait sa place (`studentSpaceRouteTypes.ts`).
 */
import { type StudentSpaceRouteTable } from "../studentSpaceRouteTypes"

export const homeRoutes: StudentSpaceRouteTable<"home"> = {}
